

var customerEmailTag = document.getElementById("customerEmail");
var customer_email = null;
if (customerEmailTag)
    customer_email = document.getElementById("customerEmail").getAttribute('data-id');

var customer_id = null;

var quizellBaseUrl = "https://api.quizell.com";
// var quizellBaseUrl = "http://127.0.0.1:8000";




var loginElement = document.getElementsByClassName("quizell-login-check");
if (loginElement) {
    checkLogin = loginElement[0].value;
}

var tokenCurrency = "USD";
// var e = document.getElementsByClassName("currencies");
// if(e)
// {
//     tokenCurrency  =e[0].value;
// }

var quizKey = 'bXWyYNLux8Hg5NmI3Cl2MS473';
var loadUrl = quizellBaseUrl + '/api/loadQuestionPage';

var updateUrl = quizellBaseUrl + '/api/updateChildRecord';
var saveUpdateUrl = quizellBaseUrl + '/api/saveChildUpdateRecord';
var editChildRecordUrl = quizellBaseUrl + '/api/editChildRecord';
// var selectedLang= $('.ly-languages-switcher-link.current_lang').data('language-code');

// var selectedLang  = 'fr';
// console.log(selectedLang);
var quizObject = {
    id: null,
    customer_email: customer_email,
    customer_id: customer_id,
    key: quizKey,
    api_token: quizKey,
    name: '',
    check_login: checkLogin,
    dob: '',
    dobDate: '',
    gender: '',
    genderText: '',
    age: '',
    answerSizeIds: [],
    answerSizeTexts: [],
    step: 0,
    web_lang: selectedLang,
    currency: tokenCurrency

}

var dobObject = {
    day: "",
    month: "",
    year: "",
}


function refreshAndRegisterLoadPage() {
    quizObject = {
        id: null,
        customer_email: quizObject.customer_email,
        customer_id: quizObject.customer_id,
        key: quizKey,
        api_token: quizKey,
        name: '',
        check_login: quizObject.check_login,
        dob: '',
        dobDate: '',
        gender: '',
        genderText: '',
        age: '',
        answerSizeIds: [],
        answerSizeTexts: [],
        step: 0,
        web_lang: selectedLang,
        currency: tokenCurrency
    }

    loadQuizRegisterChildrenPage();
}

function addClassLoader() {
    document.getElementById("quizAppID").classList.add("loader")
}

function removeClassLoader() {
    document.getElementById("quizAppID").classList.remove("loader")
}

// errors methods start
function setChildNameError() {
    document.getElementById("childName").classList.add("quizRequired")
    document.getElementById("childNameErrorMsg").innerText = "Child's Name is required"
}
function removeChildNameError() {
    document.getElementById("childName").classList.remove("quizRequired")
    document.getElementById("childNameErrorMsg").innerText = ""
}
function setChildDobError(msg = "") {
    document.getElementById("childDobErrorMsg").innerText = "Child's Birthday date is required"
}
function removeChildDobError() {
    document.getElementById("childDobErrorMsg").innerText = ""
}
function setChildGenderError() {
    document.getElementById("childGenderErrorMsg").innerText = "Child's Gender is required"
}
function removeChildGenderError() {
    document.getElementById("childGenderErrorMsg").innerText = ""
}

function setChildSizeError() {
    document.getElementById("sizeErrorMsg").innerText = "Please Choose at least one size"
}
function removeChildSizeError() {
    document.getElementById("sizeErrorMsg").innerText = ""
}



function validateSignup() {
    let status = false;
    if (getChildName() == '') {
        setChildNameError();
        status = true;
    }

    if (getChildDob()) {
        setChildDobError();
        status = true;
    }
    if (quizObject.gender == '') {
        setChildGenderError();
        status = true;
    }

    return status;
}

function validateQuestionSize() {
    let status = false;
    if (quizObject.answerSizeIds.length == 0) {
        setChildSizeError();
        status = true;
    }

    return status;
}
// errors methods end


async function loadQuizPage(step) {
    if (step == 1 && validateSignup())
        return;
    if (step == 2 && validateQuestionSize())
        return;

    quizObject.step = step;
    await fetch(loadUrl, {
        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(quizObject),
    })
        .then(response => response.text())
        .then(response => {
            document.getElementById("quizAppID").innerHTML = response;
        });
}

function loginCustomerWithAjax() {

    quizObject.customer_email = "shah@gmail.com";
    loadResultPage();
}

async function loadQuestionPage() {
    removeChildNameError();
    removeChildDobError();
    removeChildGenderError();
    if (validateSignup())
        return;
    addClassLoader();
    await fetch(loadUrl, {
        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(quizObject),
    })
        .then(response => response.text())
        .then(response => {
            document.getElementById("quizAppID").innerHTML = response;
            removeClassLoader();
        });
}

async function loadResultPage() {
    if (validateQuestionSize())
        return;
    if (quizObject.customer_email == null) {
        console.log('if result');
        document.getElementById("customerAuthId").style.display = "block";
        document.getElementById("quizAppID").style.display = "none";
    }
    else {
        console.log('else result');
        addClassLoader();
        await fetch(quizellBaseUrl + '/api/loadResultUrl', {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(quizObject),
        })
            .then(response => response.text())
            .then(response => {
                removeClassLoader();
                document.getElementById("quizAppID").innerHTML = response;
                let authElement = document.getElementById("customerAuthId");
                if (authElement)
                    document.getElementById("customerAuthId").style.display = "none";
                document.getElementById("quizAppID").style.display = "block";
            });

    }
}



async function loadQuizRegisterChildrenPage() {
    addClassLoader();
    await fetch(quizellBaseUrl + '/api/registerChildren', {
        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(quizObject),
    })
        .then(response => response.text())
        .then(response => {
            document.getElementById("quizAppID").innerHTML = response;
            removeClassLoader();
        });
}



// getters methods
function getActiveLength() {
    return document.querySelectorAll('#mainQuestionOptions .quizOptionActiveCss').length;
}
function pusPopChildSize(id, text) {
    if (quizObject.answerSizeIds.includes(id)) {
        quizObject.answerSizeTexts.splice(quizObject.answerSizeTexts.indexOf(text), 1);
        quizObject.answerSizeIds.splice(quizObject.answerSizeIds.indexOf(id), 1);
    }
    else {
        quizObject.answerSizeIds.push(id);
        quizObject.answerSizeTexts.push(text);
    }
}

function checkAndToggleClass(quizElement, cls) {
    if (quizElement) {
        quizElement.classList.toggle(cls)
    }
}
function checkContainClass(quizElement, cls) {
    if (quizElement) {
        return quizElement.classList.contains(cls)
    }
    return false;
}
async function setSize(obj, me) {
    removeChildSizeError();
    me.classList.toggle("quizOptionActiveCss");
    let getLen = getActiveLength();
    document.getElementById("detailText").innerHTML = "";

    if (getLen == 0) {
        let hiddenChildren = document.querySelectorAll('#mainQuestionOptions .quizOptionHideCss');
        await hiddenChildren.forEach(obj => {
            obj.classList.toggle('quizOptionHideCss');
        })
    }

    else if (getLen == 1) {

        if (selectedLang == "en")
            document.getElementById("detailText").innerHTML = "You can add up to 2 sizes in order to find more match";
        else
            document.getElementById("detailText").innerHTML = "Vous pouvez ajouter jusqu'Ã  2 tailles afin de trouver plus de correspondance";
        let children = document.querySelectorAll('#mainQuestionOptions span');
        let hiddenChildren = document.querySelectorAll('#mainQuestionOptions .quizOptionHideCss');
        if (hiddenChildren.length == 0) {
            await children.forEach(obj => {
                obj.classList.toggle('quizOptionHideCss');
            });
            me.classList.toggle('quizOptionHideCss')
            checkAndToggleClass(me.nextElementSibling, "quizOptionHideCss")
            checkAndToggleClass(me.previousElementSibling, "quizOptionHideCss")
        }
        else {
            if (checkContainClass(me.nextElementSibling, "quizOptionActiveCss"))
                checkAndToggleClass(me.nextElementSibling.nextElementSibling, "quizOptionHideCss")
            else
                checkAndToggleClass(me.previousElementSibling.previousElementSibling, "quizOptionHideCss")
        }

    }
    else if (getLen == 2) {
        if (checkContainClass(me.nextElementSibling, "quizOptionActiveCss"))
            checkAndToggleClass(me.nextElementSibling.nextElementSibling, "quizOptionHideCss")
        else
            checkAndToggleClass(me.previousElementSibling.previousElementSibling, "quizOptionHideCss")
    }
    else
        me.classList.toggle("quizOptionActiveCss");

    pusPopChildSize(obj.id, obj.option_value);
}

function getChildName() {
    return document.getElementById("childName").value
}
function getChildDob() {
    let dayVal = document.getElementById("dobDayId").value;
    let monthVal = document.getElementById("dobMonthId").value;
    let yearVal = document.getElementById("dobYearId").value;
    if (dayVal == '' || monthVal == '' || yearVal == '')
        return true;
    else return false;
}

function getGenderActiveLength() {
    return document.querySelectorAll('#mainQuestionOptions .quizGenderActiveCss').length;
}
// getters methods

// setter methods
function setChildGender(obj) {

    quizObject.gender = obj.id;
    quizObject.genderText = obj.option_value;

    console.log(obj);
    removeChildGenderError();
    setGenderActive(obj.option_value);
}
function setGenderActive(optionValue) {
  const ids = {
    "Boy": "childGenderBoy",
    "Girl": "childGenderGirl",
    "Baby Boy": "childGenderBabyBoy",
    "Baby Girl": "childGenderBabyGirl"
  };

  // Figure out which ID to activate; default is Girl
  const activeId = ids[optionValue] || "childGenderGirl";

  // Remove from all, then add only to the matching one
  Object.values(ids).forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove("quizGenderActiveCss");
  });

  const activeEl = document.getElementById(activeId);
  if (activeEl) activeEl.classList.add("quizGenderActiveCss");
}
function setChildName() {
    quizObject.name = getChildName();
    removeChildNameError();
}
function setChildAgeText(txt) {
    return document.getElementById("childAge").innerText = txt;
}
function setChildAge(text) {

    document.getElementById("childAge").innerText = text;
}


function setDobObject() {

    dobObject.year = document.getElementById("dobYearId").value;
    dobObject.month = document.getElementById("dobMonthId").value;
    dobObject.day = document.getElementById("dobDayId").value;
}

function setChildDob() {

    setDobObject();
    console.log(dobObject);

    if (dobObject.month == "" || dobObject.day == "" || dobObject.year == "")
        return;

    quizObject.dob = JSON.stringify(dobObject);

    quizObject.dobDate = dobObject.month + " " + dobObject.day + ", " + dobObject.year
    var dob = new Date(quizObject.dobDate);
    quizObject.age = ageCalculator(dob);
    setChildAge(quizObject.age);
    removeChildDobError();
}
// setter methods

function ageCalculator(userinput) {
    //collect input from HTML form and convert into date format
    // var userinput = document.getElementById("DOB").value;
    var dob = new Date(userinput);

    var ageageString = " ";

    //extract the year, month, and date from user date input
    var dobYear = dob.getYear();
    var dobMonth = dob.getMonth();
    var dobDate = dob.getDate();

    //get the current date from the system
    var now = new Date();
    //extract the year, month, and date from current date
    var currentYear = now.getYear();
    var currentMonth = now.getMonth();
    var currentDate = now.getDate();

    //declare a variable to collect the age in year, month, and days
    var age = {};
    var ageString = "";

    //get years
    yearAge = currentYear - dobYear;

    //get months
    if (currentMonth >= dobMonth)
        //get months when current month is greater
        var monthAge = currentMonth - dobMonth;
    else {
        yearAge--;
        var monthAge = 12 + currentMonth - dobMonth;
    }

    //get days
    if (currentDate >= dobDate)
        //get days when the current date is greater
        var dateAge = currentDate - dobDate;
    else {
        monthAge--;
        var dateAge = 31 + currentDate - dobDate;

        if (monthAge < 0) {
            monthAge = 11;
            yearAge--;
        }
    }
    //group the age in a single variable
    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
    };


    if (age.years > 0) {
        if (age.years == 1) {
            if (selectedLang == "en")
                ageageString = age.years + " year";
            else
                ageageString = age.years + " An";
        }
        else {
            if (selectedLang == "en")
                ageageString = age.years + " years";
            else
                ageageString = age.years + " Ans";
        }
    }

    else if (age.months > 0) {
        if (selectedLang == "en")
            ageageString = age.months + " Month";
        else
            ageageString = age.months + " mois";
    }

    else
        ageageString = age.days + selectedLang == "en" ? " days" : " Jours";

    return ageageString = ageageString;

}

// editChildRecord(16,1111);
function editChildRecord(id, customerId) {
    console.log('edit selectedLang', selectedLang);
    let quizUrl = editChildRecordUrl + '/' + id + '/' + customerId
    fetch(quizUrl)
        .then(response => response.json())
        .then(obj => {
            quizObject =
            {
                customer_id: obj.customer_id,
                customer_email: obj.customer_email,
                key: obj.quizKey,
                name: obj.name,
                id: id,
                dob: JSON.stringify(obj.dob),
                answerSizeIds: JSON.stringify(obj.answerSizeIds),
                answerSizeTexts: JSON.stringify(obj.answerSizeTexts),
                dobDate: obj.dobDate,
                gender: obj.gender,
                genderText: obj.genderText,
                age: obj.age,
                web_lang: selectedLang,
                step: 0,
            }

            document.body.classList.add('has-quizz-box');
            //$('body').addClass('has-quizz-box');
            updateChildRecord(quizObject);
            // document.getElementById("quizAppID").innerHTML =response;
        });
}


function refreshAndAddChild() {

    quizObject =
    {
        customer_id: customer_id,
        customer_email: customer_email,
        key: quizKey,
        api_token: quizKey,
        check_login: 0,
        name: '',
        dob: '',
        dobDate: '',
        gender: '',
        genderText: '',
        age: '',
        answerSizeIds: [],
        answerSizeTexts: [],
        step: 0,
    };
    loadQuizPage(0);
}

function updateChildRecord(obj) {
    let quizUrl = updateUrl

    addClassLoader();
    fetch(quizUrl, {
        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ web_lang: selectedLang, id: obj.id }),
    })
        .then(response => response.text())
        .then(response => {
            // updateChildRecord
            quizObject =
            {
                customer_id: obj.customer_id,
                customer_email: obj.customer_email,
                key: quizKey,
                check_login: 0,
                api_token: quizKey,
                name: obj.name,
                id: obj.id,
                dob: obj.dob,
                dobDate: obj.dobDate,
                gender: obj.gender,
                genderText: obj.genderText,
                age: obj.age,
                web_lang: selectedLang,
                answerSizeIds: JSON.parse(obj.answerSizeIds),
                answerSizeTexts: JSON.parse(obj.answerSizeTexts),
                step: 0,
            }
            removeClassLoader();
            document.getElementById("quizAppID").innerHTML = response;
        });
}

async function saveChildUpdateRecord() {

    if (validateSignup() || validateQuestionSize())
        return;

    addClassLoader();
    await fetch(saveUpdateUrl, {
        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(quizObject),
    })
        .then(response => response.text())
        .then(response => {
            removeClassLoader();
            document.getElementById("quizAppID").innerHTML = response;
        });
}


function sizeTableToggle() {
    let element = document.getElementById("shopify-section-page-size-guide")
    element.classList.toggle("hideShowTable");
    document.getElementById("nextPrevButton").classList.toggle("nextPrevButton")

    let widthTable = document.querySelector('.cv_below_main_outer_table').clientWidth;
    widthTable < 1250 ? (document.querySelectorAll('.size_guide_below').forEach((sizeGuide) => { sizeGuide.classList.remove('hide') })) : (document.querySelectorAll('.size_guide_below').forEach((sizeGuide) => { sizeGuide.classList.add('hide') }))
    widthTable < 1036 ? (document.querySelectorAll('.size_guide_above').forEach((sizeGuide) => { sizeGuide.classList.remove('hide') })) : (document.querySelectorAll('.size_guide_above').forEach((sizeGuide) => { sizeGuide.classList.add('hide') }))
    document.querySelectorAll('.cv_lb').forEach((elm) => {
        elm.addEventListener('click', (target) => {
            target.preventDefault();
            target.target.closest('tr').parentNode.querySelectorAll('.cv_lb_table').forEach((elmkg) => { elmkg.classList.remove('hide'); });
            target.target.closest('tr').parentNode.querySelectorAll('.cv_kg_table').forEach((elmkg) => { elmkg.classList.add('hide'); });
        });
    });
    document.querySelectorAll('.cv_kg').forEach((elm) => {
        elm.addEventListener('click', (target) => {
            target.preventDefault();
            target.target.closest('tr').parentNode.querySelectorAll('.cv_kg_table').forEach((elmkg) => { elmkg.classList.remove('hide'); });
            target.target.closest('tr').parentNode.querySelectorAll('.cv_lb_table').forEach((elmkg) => { elmkg.classList.add('hide'); });
        });
    });
    document.querySelector('.in_heading').addEventListener('click', (target) => {
        target.preventDefault();
        target.currentTarget.classList.add('active');
        document.querySelectorAll('.cm_heading').forEach((elm) => { elm.classList.remove('active'); });
        document.querySelectorAll('.in_table').forEach((elm) => { elm.classList.remove('hide'); });
        document.querySelectorAll('.cm_table').forEach((elm) => { elm.classList.add('hide'); });
    });
    document.querySelector('.cm_heading').addEventListener('click', (target) => {
        target.preventDefault();
        target.currentTarget.classList.add('active');
        document.querySelectorAll('.in_heading').forEach((elm) => { elm.classList.remove('active'); });
        document.querySelectorAll('.cm_table').forEach((elm) => { elm.classList.remove('hide'); });
        document.querySelectorAll('.in_table').forEach((elm) => { elm.classList.add('hide'); });
    });
    document.querySelectorAll('.size_guide_below').forEach((sizeguide) => {
        sizeguide.addEventListener('click', (target) => {
            target.preventDefault();
            document.querySelectorAll('.below_outer_table').forEach((target) => { target.scrollLeft += 300; });
        });
    });
    document.querySelectorAll('.size_guide_above').forEach((sizeguide) => {
        sizeguide.addEventListener('click', (target) => {
            target.preventDefault();
            document.querySelectorAll('.size_guide_above_table').forEach((target) => { target.scrollLeft += 300; });
        });
    });
    window.addEventListener('resize', () => {
        let widthTableMap = document.querySelector('.cv_below_main_outer_table').clientWidth;
        widthTableMap < 1250 ? (document.querySelectorAll('.size_guide_below').forEach((sizeGuide) => { sizeGuide.classList.remove('hide') })) : (document.querySelectorAll('.size_guide_below').forEach((sizeGuide) => { sizeGuide.classList.add('hide') }))
        widthTableMap < 1036 ? (document.querySelectorAll('.size_guide_above').forEach((sizeGuide) => { sizeGuide.classList.remove('hide') })) : (document.querySelectorAll('.size_guide_above').forEach((sizeGuide) => { sizeGuide.classList.add('hide') }))
    });



}


async function activeCustomerChildrenStatus(qemail, qid, url) {
    console.log(url);
    addClassLoader();
    await fetch(quizellBaseUrl + '/api/activateChildren', {
        method: 'POST', // or 'PUT'
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: qid, email: qemail }),
    })
        .then(response => response.text())
        .then(response => {
            removeClassLoader();
            window.location.href = url;
        });


    // var quizellBaseUrl = "https://quizell.com";
}


